import i18n from 'i18next'

// Non-React module consumed by services, zustand stores, and snackbar
// callers that have no component context, so `useTranslation` isn't
// available. Call `i18n.t()` directly; i18n is initialized at app bootstrap.
// Use getters so each access resolves against the current language.
const api = {
  get defaultError() {
    return i18n.t('errors.generic_retry_later', { ns: 'author' })
  },
  get storyAddBlockError() {
    return i18n.t('errors.story_add_block_restored', { ns: 'author' })
  },
  get completeStoryError() {
    return i18n.t('errors.story_completion_min_blocks', { ns: 'author' })
  },
}

const aiResponseErrorMessage = {
  qualityCleaners: {
    errorType: [
      'OverlapException',
      'DuplicateException',
      'ExcludedTextException',
      'UnsafeTextException',
      'MinimumWordsException',
      'InsufficientPartsException',
      'CleanerException',
    ],
    get message() {
      return i18n.t('errors.generation_validation', { ns: 'author' })
    },
  },
  parsingErrors: {
    errorType: ['ParseException'],
    get message() {
      return i18n.t('errors.generation_parsing', { ns: 'author' })
    },
  },
  aiConnectionErrors: {
    errorType: ['OpenAiException'],
    get message() {
      return i18n.t('errors.generation_connectivity', { ns: 'author' })
    },
  },
  defaultError: {
    get message() {
      return i18n.t('errors.generic_retry_later', { ns: 'author' })
    },
  },
}

export const ErrorMessage = {
  api,
  aiResponseErrorMessage,
  getAIResponseErrorMessage: (error?: string | null) => {
    if (aiResponseErrorMessage.qualityCleaners.errorType.find((err) => err === error)) {
      return aiResponseErrorMessage.qualityCleaners.message
    }

    if (aiResponseErrorMessage.parsingErrors.errorType.find((err) => err === error)) {
      return aiResponseErrorMessage.parsingErrors.message
    }

    if (aiResponseErrorMessage.aiConnectionErrors.errorType.find((err) => err === error)) {
      return aiResponseErrorMessage.aiConnectionErrors.message
    }

    return aiResponseErrorMessage.defaultError.message
  },
}
